import { useEffect, useState } from 'react';
import styles from './ArchivPhoto.module.scss';
import linkArrow from '../../assets/img/linkArrow.png';
import downloadArrow from '../../assets/img/downloadArrow.svg';
import { getAllArchivePhoto } from '../../apirequests/apirequests';
import noPhoto from '@assets/img/noPhoto.png';
import { server } from '../../apirequests/apirequests';
import { useTranslation } from 'react-i18next';

const ArchivPhoto = () => {
  const { i18n } = useTranslation();

  const [showTooltip, setShowTooltip] = useState(null);
  const [coordinates, setCoordinates] = useState({ x: 0, y: 0 });
  const [tooltipTimeout, setTooltipTimeout] = useState(null);
  const [tooltipText, setTooltipText] = useState('');
  const [dataAlbom, setDataAlbom] = useState([]);

  useEffect(() => {
    getAllArchivePhoto().then(resp => {
      setDataAlbom(resp?.data?.archives || []);
    });
  }, []);

  const handleMouseEnter = (key, text) => {
    const timeout = setTimeout(() => {
      setShowTooltip(key);
      setTooltipText(text);
    }, 300);
    setTooltipTimeout(timeout);
  };

  const handleMouseLeave = () => {
    clearTimeout(tooltipTimeout);
    setShowTooltip(null);
    setTooltipText('');
  };

  const handleMouseMove = event => {
    setCoordinates({ x: event.clientX, y: event.clientY });
  };

  const handleDownload = (e, fileUrl, fileName) => {
    e.preventDefault();
    e.stopPropagation();
    if (!fileUrl) return;

    // Прямая ссылка — браузер качает потоком, без загрузки всего файла в память
    const link = document.createElement('a');
    link.href = `${server}/${fileUrl}`;
    link.download = fileName || fileUrl.split('/').pop() || 'archive.zip';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openLabel = i18n.language === 'ru' ? 'Перейти в альбом' : 'Go to album';
  const downloadLabel = i18n.language === 'ru' ? 'Скачать архив' : 'Download archive';

  return (
    <section className={styles.photoGrid}>
      {dataAlbom.map((photo, index) => {
        const hasLink = Boolean(photo.url);
        const hasFile = Boolean(photo.fileZip?.url);
        const coverSrc =
          photo?.file?.url && server ? `${server}/${photo.file.url}` : noPhoto;

        return (
          <div key={photo.id || index} className={styles.cardWrap}>
            <div
              className={styles.photoItem}
              onMouseEnter={() =>
                hasLink && handleMouseEnter(`${index}-link`, openLabel)
              }
              onMouseLeave={handleMouseLeave}
              onMouseMove={handleMouseMove}
            >
              {hasLink ? (
                <a
                  href={photo.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.photoCoverLink}
                >
                  <img src={coverSrc} alt={photo.name} className={styles.photo} />
                </a>
              ) : (
                <img src={coverSrc} alt={photo.name} className={styles.photo} />
              )}

              <div className={styles.photoTitleWrapper}>
                <p className={styles.photoTitle}>{photo.name}</p>
              </div>

              <div className={styles.actions}>
                {hasFile && (
                  <button
                    type="button"
                    className={styles.actionBtn}
                    onClick={e => handleDownload(e, photo.fileZip.url, photo.fileZip?.name)}
                    onMouseEnter={() => handleMouseEnter(`${index}-download`, downloadLabel)}
                    onMouseLeave={handleMouseLeave}
                    onMouseMove={handleMouseMove}
                    aria-label={downloadLabel}
                  >
                    <img src={downloadArrow} alt="" />
                  </button>
                )}
                {hasLink && (
                  <a
                    href={photo.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.actionBtn}
                    onMouseEnter={() => handleMouseEnter(`${index}-link`, openLabel)}
                    onMouseLeave={handleMouseLeave}
                    onMouseMove={handleMouseMove}
                    aria-label={openLabel}
                  >
                    <img src={linkArrow} className={styles.linkArrow} alt="" />
                  </a>
                )}
              </div>
            </div>

            {(showTooltip === `${index}-link` || showTooltip === `${index}-download`) && (
              <div
                style={{
                  left: coordinates.x + 20,
                  top: coordinates.y + 10,
                }}
                className={styles.repName}
              >
                {tooltipText}
              </div>
            )}
          </div>
        );
      })}
    </section>
  );
};

export default ArchivPhoto;
